<div
  class="bg-hrp-subtle-200 h-full w-full flex flex-row flex-wrap items-center justify-start p-4 text-left rounded-md"
>
  <p class="hrp-text-body-xs-emph text-hrp-subtle-800">{{ meta?.defaultMessage }}</p>
</div>
